import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-950">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-900 text-4xl text-primary-400">
        <i className="ri-film-line"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl md:text-4xl font-bold text-foreground-50">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-400">
        你访问的页面不存在：<span className="font-mono text-foreground-300">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
        <Link
          to="/category"
          className="px-6 py-3 rounded-md border border-background-600 text-foreground-100 text-sm font-medium hover:border-accent-500 hover:text-accent-400 transition-colors"
        >
          浏览电影分类
        </Link>
      </div>
    </div>
  );
}